import React, {FC} from 'react';

/** 代理合作机制英文正文（i18n：壳组件按语言选择 zh/en 内容组件；h1 在壳 hero，正文从 h2 起，
 * 元素结构与 zh.tsx 1:1 对应，排版由 Prose（.v3-prose）提供）。2026-09-16 重写，随 zh.tsx 同步扩充。 */
const EnContent: FC = () => {
  return (
    <>
      <section>
        <h2>What is the Agent Partnership Program</h2>
        <p>
          To serve more sellers who need cross-border content localization, and to give back to loyal users who
          introduce Xiangji to fellow sellers, Xiangji has launched an Agent Partnership Program. Simply share your
          personal referral link with friends running cross-border businesses who need product image generation, video
          localization, or main/detail image generation — once they sign up as Xiangji users, you earn a referral reward
          on every single payment they make afterward, permanently, with no expiration and no need to re-invite.
        </p>
        <div className="v3-note">
          <p>
            The program is open to every Xiangji user with no extra qualification or approval required — sign up and you
            already have your own referral link, ready to share anytime.
          </p>
        </div>
      </section>
      <section>
        <h2>Reward Rules</h2>
        <p>
          After a friend signs up through your referral link and completes a payment, you can choose one of the
          following two reward options per transaction — the two are mutually exclusive and settled per payment:
        </p>
        <ul>
          <li>
            <strong>15% quota reward</strong>: converted from your friend's payment amount into an equivalent amount of
            Xiangji service credits, usable directly in your own account for image generation, video localization, or
            listing content generation — ideal if you're an active Xiangji user yourself;
          </li>
          <li>
            <strong>10% cash reward</strong>: paid out directly in cash — ideal if you prefer immediate returns.
          </li>
        </ul>
        <p>
          For example: Lao Wang, a Xiangji user, has a good friend named Xiaoli who is starting a cross-border
          e-commerce business and needs product image generation and listing content services. Believing that Xiangji
          delivers great results at a low price, Lao Wang shared his referral link with Xiaoli. After Xiaoli signed up
          and purchased 10,000 image credits, Lao Wang could choose a <strong>15% quota reward</strong> (1,500 image
          credits) or a <strong>10% cash reward</strong>.
        </p>
      </section>
      <section>
        <h2>How to Become an Agent</h2>
        <h3>1. Get your personal referral link</h3>
        <p>
          After logging into the Xiangji workspace, find your personal referral link in your account center — it's
          permanently tied to your account.
        </p>
        <img
          alt="Referral link page"
          decoding="async"
          loading="lazy"
          src="https://www.xiangjifanyi.com/doc/assets/images/proxyLink-b19297b66a83019a38381eedec4e6a15.jpg"
        />
        <h3>2. Send the link to seller friends who are going global</h3>
        <p>
          They'll need to sign up with a phone number — no need to enter your referral code manually, the system links
          the referral automatically.
        </p>
        <h3>3. Track referrals and rewards anytime in your "User List"</h3>
        <p>
          Once a friend signs up, you can see every referred customer in the workspace's "User List" and track their
          payments and reward status.
        </p>
        <img
          alt="Referred customer list page"
          decoding="async"
          loading="lazy"
          src="https://www.xiangjifanyi.com/doc/assets/images/customerList-6a1f51325e636766f7270d307f93568b.jpg"
        />
      </section>
    </>
  );
};

export default EnContent;
